import React, { useMemo } from 'react';
import './ExpenseReports.css';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../utils/formatCurrency';

function ExpenseReports({ expenses }) {
  const { t } = useTranslation();

  const stats = useMemo(() => {
    let total = 0;
    const byCategory = {};

    expenses.forEach((expense) => {
      const amount = parseFloat(expense.amount);
      total += amount;

      if (!byCategory[expense.category]) {
        byCategory[expense.category] = 0;
      }
      byCategory[expense.category] += amount;
    });

    return { total, byCategory };
  }, [expenses]);

  // Sort categories by amount descending
  const sortedCategories = Object.entries(stats.byCategory).sort((a, b) => b[1] - a[1]);

  return (
    <div className="expense-reports">
      <div className="report-card total-card">
        <h3>{t('expenses.totalExpenses')}</h3>
        <p className="total-amount">{formatCurrency(stats.total)}</p>
      </div>

      <div className="report-card category-card">
        <h3>{t('expenses.byCategory')}</h3>
        <div className="category-list">
          {sortedCategories.length > 0 ? (
            sortedCategories.map(([category, amount]) => (
              <div key={category} className="category-item">
                <div className="category-info">
                  <span className="category-name">{category}</span>
                  <span className="category-amount">{formatCurrency(amount)}</span>
                </div>
                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${(amount / stats.total) * 100}%` }}
                  ></div>
                </div>
              </div>
            ))
          ) : (
            <p className="no-data">{t('common.noData')}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExpenseReports;
